import {
  AnyAction,
  createListenerMiddleware,
  isAnyOf,
  ListenerMiddlewareInstance,
  ThunkDispatch,
  UnsubscribeListener,
} from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { AppsFilterListenerEffect } from '../effects/apps-filter-listener.effect';
import {
  addPagination,
  filterAppsByCategories,
  filterAppsByIsFeatured,
  filterAppsByNameOrDescription,
  filterAppsByPlatforms,
  filterAppsByStatus,
  resetPagination,
} from '../store/slices/apps.slice';

export const appsFilterListener: ListenerMiddlewareInstance<
  AppRootState,
  ThunkDispatch<AppRootState, undefined, AnyAction>
> = createListenerMiddleware();

export const unsubscribeAppsFilterListener: UnsubscribeListener =
  appsFilterListener.startListening({
    matcher: isAnyOf(
      filterAppsByNameOrDescription,
      filterAppsByStatus,
      filterAppsByCategories,
      filterAppsByPlatforms,
      filterAppsByIsFeatured,
      addPagination,
      resetPagination
    ),
    effect: AppsFilterListenerEffect,
  });
